import emitter from '../../../scripts/lib/event-emitter';

const name = 'copyright-notice';

const legalPrefix = 'Copyrights:';
const legalSeparator = ', ';
const legalIndexSeparator = ' - ';
const badgePrefix = '©';

export default class CopyrightNotice {

  constructor ($el) {

    this.$el = $el;

    this.onUpdateCopyrightNotices = this.onUpdateCopyrightNotices.bind(this);

    emitter.addListener('updateCopyrightNotices', this.onUpdateCopyrightNotices);

    this.onUpdateCopyrightNotices();
  }

  onUpdateCopyrightNotices() {
    const copyrightNotices = [];
    this.$copyrightItems = document.querySelectorAll(`[data-${name}]`);

    for (let i = 0; i < this.$copyrightItems.length; i++) {
      const $item = this.$copyrightItems[i];
      const copyrightText = $item.dataset.copyrightNotice;
      const indexInNotices = copyrightNotices.indexOf(copyrightText);

      if (indexInNotices > -1) {
        this.setBadge($item, indexInNotices + 1);
        continue;
      }

      copyrightNotices.push(`${copyrightText}`);

      this.setBadge($item, copyrightNotices.length);
    }

    if (copyrightNotices.length) {
      const copyrightNotice = copyrightNotices
        .map((copyrightText, index) => `${index + 1}${legalIndexSeparator}${copyrightText}`)
        .join(legalSeparator);

      this.$el.innerText = `${legalPrefix} ${copyrightNotice}`;
    }
  }

  setBadge($item, index) {
    const $itemBadge = $item.querySelector(`.${name}-badge`);

    if (!$itemBadge) {
      return;
    }

    $itemBadge.innerText = `${badgePrefix} ${index}`;
  }
}
